import React, { useEffect, useState } from 'react';
import {
	Nav,
	NavItem,
	NavLink,
	TabContent,
	TabPane,
} from 'reactstrap';
import classnames from 'classnames';
import BASE_URL_WITH_PROTOCOL from '../../../utils/dynamicUrl';
import useAxios from '../../../api/useAxios';
import { useQueryClient } from 'react-query';
import IP from '../../../utils/variable';
import MatchingPriority from './components/matching-priority';

const Settings = () => {
	const baseURL = `${BASE_URL_WITH_PROTOCOL}/api`;
	const api = useAxios();
	const queryClient = useQueryClient();
	const [activeTab, setActiveTab] = useState('1');

	const toggleTab = (tab) => {
		if (activeTab !== tab) setActiveTab(tab);
	};

	// Sanitize Image URLs
	const sanitizedImage = (image) => {
		if (!image) return null;
		try {
			const url = new URL(image);
			url.search = '';
			return url.toString();
		} catch {
			return `${IP}${image}`;
		}
	};

	return (
		<div className="page-content">
			<div className="container">
				<div className="py-4">
					<Nav className='settings-tabs' tabs pills>
						
						<NavItem>
							<NavLink
								className={classnames({ active: activeTab === '7' })}
								onClick={() => toggleTab('7')}
							>
								Tracking Priority
							</NavLink>
						</NavItem>
						
					</Nav>
					<TabContent activeTab={activeTab} className="border rounded mt-3 px-3 py-3">
						
						<TabPane tabId="1">
							<h4 className="py-4">Set Matching Priority</h4>
							<MatchingPriority activeTab={activeTab} />
						</TabPane>
					</TabContent>
				</div>
			</div>
		</div>
	);
};

export default Settings;
